(function () {
  try {
    var params = new URLSearchParams(window.location.search || '');
    var initialFeed = String(params.get('f') || 'all').toLowerCase();
    if (initialFeed !== 'available') return;
    // The runtime owns filtered requests, including delivery intent and pricing.
    if (['budget','composition'].some(function (key) { return params.has(key) && params.get(key) !== 'all'; })) return;
    var slugify = function (value) {
      return String(value || '').trim().toLowerCase().normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '').slice(0, 80);
    };
    var partnerSlug = slugify(params.get('partner') || params.get('partnerSlug') || '');
    var occasion = String(params.get('occasion') || 'all').trim().toLowerCase() || 'all';
    var cap = '';
    if (!partnerSlug) {
      var saved = JSON.parse(window.localStorage.getItem('florame_cap_state') || 'null');
      var fresh = saved && saved.verified === true && (Date.now() - Number(saved.ts || 0)) <= (2 * 60 * 60 * 1000);
      cap = fresh ? String(saved.cap || '').trim() : '';
      if (!/^\d{4,5}$/.test(cap)) return;
    }
    var stateKey = (partnerSlug ? 'inventory' : cap) + ':' + occasion + ':' + (partnerSlug || 'global');
    var payload = { page: 1, onlyAvailable: true, limit: 20, sortField: 'createdAt', sortDirection: 'desc' };
    if (partnerSlug) payload.partnerSlug = partnerSlug;
    else payload.cap = cap;
    if (occasion !== 'all') payload.occasion = occasion;
    var startedAt = performance && performance.now ? performance.now() : Date.now();
    var promise = (window.FlorameReadCache && window.FlorameReadCache.fetch || window.fetch)('https://us-central1-flower-ai-2d7aa.cloudfunctions.net/getGeneratedBouquets', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.json();
    }).then(function (data) { return { ok: true, data: data }; })
      .catch(function (error) { return { ok: false, error: error }; });
    window.__florameHomeAvailablePrime = { key: stateKey, payload: payload, promise: promise, startedAt: startedAt, used: false };
  } catch (_) {}
})();
